const ChatbotMessengerState = Object.freeze({
	OPEN: 'open',
	MINIMIZED: 'minimized',
	HIDE: 'hide',
});

const ChatbotTriggers = Object.freeze({
	FeedbackButton: 'feedbackBtn',
	AddFunds: 'addFunds',
	CancelAccount: 'cancelAccount',
});

export { ChatbotTriggers, ChatbotMessengerState };
